export default __webpack_public_path__ + "static/media/forestly-expl-nn-02_EN.06255a1a.png";